



  var targetHash = window.location.hash;

  if (targetHash) {
      // 1. ブラウザが勝手にジャンプするのを防ぐため、URLから一瞬だけハッシュを消す
      history.replaceState(null, null, window.location.pathname + window.location.search);
  }

  $(window).on('load', function() {
      // 2. 対象の要素が存在するか確認
      if (targetHash && $(targetHash).length) {
          var wWidth = $(window).width();
          var headerHeight = $('.header').outerHeight() || 0; 
          var p = $(targetHash).offset();

          // 3. 画像などの読み込み完了後、正しい位置（ヘッダー考慮）へアニメーション
          $('html,body').animate({
              scrollTop: p.top - headerHeight
          }, 1500, function() {
              // 4. スクロールが完了したら、URLにハッシュを戻す（URLの見た目を保つため）
              history.replaceState(null, null, window.location.pathname + window.location.search + targetHash);
          });
      }
  });

  $(document).ready(function(){



    $('a[href^="#"]').click(function() {
      var wWidth = $(window).width();
      
      var headerHeight = $('.header').outerHeight(); 

      if ($($(this).attr('href')).length) {
          var p = $($(this).attr('href')).offset();

          if (wWidth <= 640) {
              $('html,body').animate({
                  scrollTop: p.top - headerHeight
              }, 1500);
          } else {
              $('html,body').animate({
                  scrollTop: p.top - headerHeight
              }, 1500);
          }
      }
      return false;
  });



    var anim = function(){

      var st1 = ( $('html').scrollTop() > 0 ) ? $('html').scrollTop() : 0;
      var st2 = ( $('body').scrollTop() > 0 ) ? $('body').scrollTop() : 0;
      var st = ( st1 > st2 ) ? st1 : st2;
    
      $('.anim').each(function(){
    
          var triggerPos = st + (window.innerHeight*0.85);
    
          if( triggerPos >= $(this).offset().top && !$(this).hasClass('is-animated') ){
              $(this).addClass('is-animated');
          }
      });
    };
    





    $(window).on('load scroll', function() {

      var wWidth = $(window).width();

    
    
      anim();
    

          if ($(this).scrollTop() > 10){
        
            $('.topPage').fadeIn();
            $('.footer-sp-button').fadeIn();
            
          }else{
            $('.topPage').fadeOut();
            $('.footer-sp-button').fadeOut();
            
          }
        


  });


  $('.pickup__slider').slick({
  
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: false,
    dots: false,
    arrows:true,
    prevArrow:"<span class='next prev'></span>",
    nextArrow:"<span class=' next'></span>",
    swipe : true,
    autoplay: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
        
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('.Product_AddSlider_Thumbnail').slick({
  
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: false,
    dots: false,
    arrows:true,
    prevArrow:"<span class='next prev'></span>",
    nextArrow:"<span class=' next'></span>",
    swipe : true,
    autoplay: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
        
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });





  setTimeout(function() { 
    $(".product-form__quantity label").text('数量');
 
    var str = $('.product-count__text span').text();
      str = str.replace("products", "商品");
      $('.product-count__text span').text(str);
  }, 1000);



  setTimeout(function() { 
    $(".spr-header-title").text("カスタマーレビュー");
    $(".spr-summary-actions-newreview").text("レビューを書く");
    $(".spr-summary-caption").text("まだレビューはありません");
    $(".spr-form-title").text("レビューを書く");
    $('input[type=submit]').val('送信');
    $('.spr-form-contact input[type=text]').attr("placeholder", "名前を入力");
    $('.spr-form-review input[type=text]').attr("placeholder", "レビューにタイトルを付けます。");
    $('.spr-form-review textarea').attr("placeholder", "ここにコメントを書いてください。");

    $('.drawer__header .drawer__title').text("ショッピングカート");



  }, 4000);

  // 



$(window).on('load', function(){
    $('[data-filter-type="Price"]').removeClass('is-collapsed');
});


$(document).ready(function() {
    $('.section-column .inner').each(function() {
        var $title = $(this).find('.title__txt');
        var $detail = $(this).find('.c__txt');
        
        var titleLineHeight = parseFloat($title.css('line-height'));
        var detailLineHeight = parseFloat($detail.css('line-height'));
        
        // ここで行数を設定
        var titleLines = 2;
        var detailLines = 3;
        
        $title.css('height', titleLineHeight * titleLines + 'px');
        $detail.css('height', detailLineHeight * detailLines + 'px');
    });
});



    $(window).on('scroll', function() {
        var fullHeight = $(document).height();
        var windowHeight = $(window).height();
        var scrollPosition = $(window).scrollTop();
        var offset = 100; // 猶予
        
        if (fullHeight <= windowHeight + scrollPosition + offset) {
            $('#floating-nav').css('position', 'static');
        } else {
            $('#floating-nav').css({
                'position': 'fixed',
                'bottom': '0'
            });
        }
    });


    

  });

// ヘッダーの高さを取得してCSS変数にセットする関数
function updateHeaderHeight() {
    var header = document.querySelector('.header-back');
    if (header) {
        var headerHeight = header.offsetHeight;
        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    }
}
// ページ読み込み時と、画面サイズが変更された時に高さを再計算する
window.addEventListener('DOMContentLoaded', updateHeaderHeight);
window.addEventListener('resize', updateHeaderHeight);


function changeImageSource() {
  var headerElement = document.querySelector('header');
  var imgElement = document.querySelector('.header__heading-link img');
  var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  
  // コンピューテッドスタイルからheaderのbackground-colorを取得
  var headerBgColor = window.getComputedStyle(headerElement).backgroundColor;
  
  // background-colorが#222の時は関数をreturnして終了
  if (headerBgColor === 'rgb(34, 34, 34)') {
    return;
  }

}

// ページのロード時に関数を実行
window.addEventListener('load', function() {
  // ページの読み込みが完了したタイミングでchangeImageSource関数を呼び出す
  changeImageSource();
});

// ビューポートのサイズが変更された時にも関数を実行
window.addEventListener('resize', changeImageSource);



// クラス名が 'ruffruff-table-of-contents' の要素を選択
var element = document.querySelector('.ruffruff-table-of-contents');

// もし要素が存在する場合、インラインスタイルを全て削除
if(element) {
    element.setAttribute('style', '');
}

var elements = document.querySelectorAll('.ruffruff-table-of-contents *');

// 各要素のインラインスタイルを全て削除
elements.forEach(function(element) {
    element.setAttribute('style', '');
});

$(document).ready(function() {
    var url = window.location.href;



    // URLに「stk」が含まれていて、「dice」が含まれていないかをチェック
    if (url.indexOf('stk') !== -1 && url.indexOf('dice') === -1) {
        // 「stk」が含まれていて、「dice」が含まれていない場合、テキストを変更
        $('.product-form__quantity .form__label').text('セット数');
        // 該当の quantity ブロックを非表示
        $('.product-form__input.product-form__quantity').hide();
    }
});

$(document).ready(function() {
    $('.select__select').on('change', function(e) {
        e.preventDefault();
        
        var selectedOptionText = $(this).find('option:selected').text();

        $('.selected-option-value').text(selectedOptionText);
    });
    
    $('.select__select').trigger('change');
});

$(document).ready(function() {
    $('#insta-feed').appendTo('.instagram__wrapper');
});


$(window).scroll(function() {
  $("#myHeader").addClass("active");
    var scroll = $(window).scrollTop();
    if (scroll >= 100) { // 100ピクセル以上スクロールした場合に 'active' クラスを追加
        $("#myHeader").addClass("active");
    } else {
        $("#myHeader").removeClass("active");
    }
});
$(window).scroll(function() {
  $("#MainContent").addClass("active");
    var scroll = $(window).scrollTop();
    if (scroll >= 100) { // 100ピクセル以上スクロールした場合に 'active' クラスを追加
        $("#MainContent").addClass("active");
    } else {
        $("#MainContent").removeClass("active");
    }
});

document.addEventListener("DOMContentLoaded", function() {
  var elements = document.querySelectorAll(".metafield-single_line_text_field");

  elements.forEach(function(element) {
    var text = element.innerHTML;
    text = text.replace(/（/g, '(').replace(/）/g, ')');
    element.innerHTML = text + ' ～';
  });
});
document.addEventListener('DOMContentLoaded', function () {
  // .price__regular 内の .metafield-single_line_text_field をすべて取得
  const priceElements = document.querySelectorAll('.price__regular .metafield-single_line_text_field');

  priceElements.forEach(element => {
    // テキストに "～" が含まれている場合、それを削除する
    if (element.textContent.includes("～")) {
      element.textContent = element.textContent.replace(/～/g, '');
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    // .selected-option-value クラスを持つ要素をすべて取得
    const optionElements = document.querySelectorAll('.selected-option-value');

    optionElements.forEach(element => {
      // テキストに含まれている全角括弧（「（」と「）」）を半角括弧に置き換える
      element.textContent = element.textContent.replace(/（/g, '(').replace(/）/g, ')');
    });
  }, 1000); // 1000ミリ秒（1秒）後に実行
});
document.addEventListener("DOMContentLoaded", function() {
  // first-mega-menu クラスを持つ li 要素をすべて取得
  const listItems = document.querySelectorAll("li.first-mega-menu");
  
  // 1つ目の li に "SHOPPING" を追加
  if (listItems.length > 0) {
    listItems[0].insertAdjacentText("afterbegin", "SHOPPING ");
  }

  // 3つ目の li に "ABOUT US" を追加
  if (listItems.length > 2) {
    listItems[2].insertAdjacentText("afterbegin", "ABOUT US ");
  }
});

